import { Injectable } from '@angular/core';
import { OnePProjectCostTotalsDTO } from '../api/api-clientInformation';

@Injectable({
  providedIn: 'root',
})
export class CostTotalsService {
  public forecastCostTotals = {} as OnePProjectCostTotalsDTO;
  public hasDraftCostTotals(initiativeCostTotals: OnePProjectCostTotalsDTO): boolean {
    const today = new Date();
    const diff = this.getDifferences(initiativeCostTotals, this.forecastCostTotals, today.getMonth() + 1);
    return this.calculateTotals(diff) !== 0;
  }

  public clearTill(t1: OnePProjectCostTotalsDTO,
    month: number = 0){
    var result = {} as OnePProjectCostTotalsDTO as any;
    const monthMapping: { [key: string]: number } = {
      jan: 1,
      feb: 2,
      mar: 3,
      apr: 4,
      may: 5,
      jun: 6,
      jul: 7,
      aug: 8,
      sep: 9,
      oct: 10,
      nov: 11,
      dec: 12,
    };
    const t1Array = t1 as any;
    Object.keys(t1Array).forEach((key) => {
      const monthKey = key.toLowerCase().substring(0, 3);
      if(monthMapping[monthKey] >= month){
        result[key] = t1Array[key] ?? 0;
      }
    });
    return result;
  }

  public getDifferences(
    t1: OnePProjectCostTotalsDTO,
    t2: OnePProjectCostTotalsDTO,
    startingFromMonth: number = 1
  ): OnePProjectCostTotalsDTO {
    var result = {} as OnePProjectCostTotalsDTO as any;
    const monthMapping: { [key: string]: number } = {
      jan: 1,
      feb: 2,
      mar: 3,
      apr: 4,
      may: 5,
      jun: 6,
      jul: 7,
      aug: 8,
      sep: 9,
      oct: 10,
      nov: 11,
      dec: 12,
    };
    const t1Array = t1 as any;
    const t2Array = t2 as any;
    Object.keys(t1Array).forEach((key) => {
      const monthKey = key.toLowerCase().substring(0, 3);
      if(monthMapping[monthKey] >= startingFromMonth){
        const initialValue = t1Array[key] ?? 0;
        const updatedValue = t2Array[key] ?? 0;
        if (initialValue !== updatedValue) {
          result[key] = updatedValue === 0 ? initialValue : updatedValue;
        } else {
          result[key] = undefined;
        }
      } else {
        result[key] = undefined;
      }
    });
    return result;
  }

  public calculateTotals(totals: OnePProjectCostTotalsDTO): number {
    return Math.round((
      (totals.janMaterial ?? 0) +
      (totals.janService ?? 0) +
      (totals.janOther ?? 0) +
      (totals.febMaterial ?? 0) +
      (totals.febService ?? 0) +
      (totals.febOther ?? 0) +
      (totals.marMaterial ?? 0) +
      (totals.marService ?? 0) +
      (totals.marOther ?? 0) +
      (totals.aprMaterial ?? 0) +
      (totals.aprService ?? 0) +
      (totals.aprOther ?? 0) +
      (totals.mayMaterial ?? 0) +
      (totals.mayService ?? 0) +
      (totals.mayOther ?? 0) +
      (totals.junMaterial ?? 0) +
      (totals.junService ?? 0) +
      (totals.junOther ?? 0) +
      (totals.julMaterial ?? 0) +
      (totals.julService ?? 0) +
      (totals.julOther ?? 0) +
      (totals.augMaterial ?? 0) +
      (totals.augService ?? 0) +
      (totals.augOther ?? 0) +
      (totals.sepMaterial ?? 0) +
      (totals.sepService ?? 0) +
      (totals.sepOther ?? 0) +
      (totals.octMaterial ?? 0) +
      (totals.octService ?? 0) +
      (totals.octOther ?? 0) +
      (totals.novMaterial ?? 0) +
      (totals.novService ?? 0) +
      (totals.novOther ?? 0) +
      (totals.decMaterial ?? 0) +
      (totals.decService ?? 0) +
      (totals.decOther ?? 0)
    )*100)/100;
  }

  public mergeCostTotal(forecast?: any, initiative?: any): OnePProjectCostTotalsDTO {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;

  const monthMapping: { [key: string]: number } = {
    jan: 1,
    feb: 2,
    mar: 3,
    apr: 4,
    may: 5,
    jun: 6,
    jul: 7,
    aug: 8,
    sep: 9,
    oct: 10,
    nov: 11,
    dec: 12,
  };

  const mergedData: any = {} as any;

  Object.keys(monthMapping).forEach((monthKey) => {
    const monthNumber = monthMapping[monthKey];
    const isFutureMonth = monthNumber >= currentMonth;

    mergedData[`${monthKey}Material`] = isFutureMonth
      ? forecast[`${monthKey}Material`]
      : initiative[`${monthKey}Material`];
    mergedData[`${monthKey}Service`] = isFutureMonth
      ? forecast[`${monthKey}Service`]
      : initiative[`${monthKey}Service`];
    mergedData[`${monthKey}Other`] = isFutureMonth
      ? forecast[`${monthKey}Other`]
      : initiative[`${monthKey}Other`];
  });

  return mergedData;
}

  public isAllZeros(totals: OnePProjectCostTotalsDTO): boolean {
    return totals.janMaterial === null &&
      totals.janService === null &&
      totals.janOther === null &&
      totals.febMaterial === null &&
      totals.febService === null &&
      totals.febOther === null &&
      totals.marMaterial === null &&
      totals.marService === null &&
      totals.marOther === null &&
      totals.aprMaterial === null &&
      totals.aprService === null &&
      totals.aprOther === null &&
      totals.mayMaterial === null &&
      totals.mayService === null &&
      totals.mayOther === null &&
      totals.junMaterial === null &&
      totals.junService === null &&
      totals.junOther === null &&
      totals.julMaterial === null &&
      totals.julService === null &&
      totals.julOther === null &&
      totals.augMaterial === null &&
      totals.augService === null &&
      totals.augOther === null &&
      totals.sepMaterial === null &&
      totals.sepService === null &&
      totals.sepOther === null &&
      totals.octMaterial === null &&
      totals.octService === null &&
      totals.octOther === null &&
      totals.novMaterial === null &&
      totals.novService === null &&
      totals.novOther === null &&
      totals.decMaterial === null &&
      totals.decService === null &&
      totals.decOther === null;
  }

  public setDifference(
    totals: OnePProjectCostTotalsDTO,
    initiativeCostTotals: OnePProjectCostTotalsDTO
  ) {
    initiativeCostTotals.janMaterial =
      totals.janMaterial !== 0
        ? totals.janMaterial
        : initiativeCostTotals.janMaterial;
    initiativeCostTotals.janService =
      totals.janService !== 0
        ? totals.janService
        : initiativeCostTotals.janService;
    initiativeCostTotals.janOther =
      totals.janOther !== 0 ? totals.janOther : initiativeCostTotals.janOther;
    initiativeCostTotals.febMaterial =
      totals.febMaterial !== 0
        ? totals.febMaterial
        : initiativeCostTotals.febMaterial;
    initiativeCostTotals.febService =
      totals.febService !== 0
        ? totals.febService
        : initiativeCostTotals.febService;
    initiativeCostTotals.febOther =
      totals.febOther !== 0 ? totals.febOther : initiativeCostTotals.febOther;
    initiativeCostTotals.marMaterial =
      totals.marMaterial !== 0
        ? totals.marMaterial
        : initiativeCostTotals.marMaterial;
    initiativeCostTotals.marService =
      totals.marService !== 0
        ? totals.marService
        : initiativeCostTotals.marService;
    initiativeCostTotals.marOther =
      totals.marOther !== 0 ? totals.marOther : initiativeCostTotals.marOther;
    initiativeCostTotals.aprMaterial =
      totals.aprMaterial !== 0
        ? totals.aprMaterial
        : initiativeCostTotals.aprMaterial;
    initiativeCostTotals.aprService =
      totals.aprService !== 0
        ? totals.aprService
        : initiativeCostTotals.aprService;
    initiativeCostTotals.aprOther =
      totals.aprOther !== 0 ? totals.aprOther : initiativeCostTotals.aprOther;
    initiativeCostTotals.mayMaterial =
      totals.mayMaterial !== 0
        ? totals.mayMaterial
        : initiativeCostTotals.mayMaterial;
    initiativeCostTotals.mayService =
      totals.mayService !== 0
        ? totals.mayService
        : initiativeCostTotals.mayService;
    initiativeCostTotals.mayOther =
      totals.mayOther !== 0 ? totals.mayOther : initiativeCostTotals.mayOther;
    initiativeCostTotals.junMaterial =
      totals.junMaterial !== 0
        ? totals.junMaterial
        : initiativeCostTotals.junMaterial;
    initiativeCostTotals.junService =
      totals.junService !== 0
        ? totals.junService
        : initiativeCostTotals.junService;
    initiativeCostTotals.junOther =
      totals.junOther !== 0 ? totals.junOther : initiativeCostTotals.junOther;
    initiativeCostTotals.julMaterial =
      totals.julMaterial !== 0
        ? totals.julMaterial
        : initiativeCostTotals.julMaterial;
    initiativeCostTotals.julService =
      totals.julService !== 0
        ? totals.julService
        : initiativeCostTotals.julService;
    initiativeCostTotals.julOther =
      totals.julOther !== 0 ? totals.julOther : initiativeCostTotals.julOther;
    initiativeCostTotals.augMaterial =
      totals.augMaterial !== 0
        ? totals.augMaterial
        : initiativeCostTotals.augMaterial;
    initiativeCostTotals.augService =
      totals.augService !== 0
        ? totals.augService
        : initiativeCostTotals.augService;
    initiativeCostTotals.augOther =
      totals.augOther !== 0 ? totals.augOther : initiativeCostTotals.augOther;
    initiativeCostTotals.sepMaterial =
      totals.sepMaterial !== 0
        ? totals.sepMaterial
        : initiativeCostTotals.sepMaterial;
    initiativeCostTotals.sepService =
      totals.sepService !== 0
        ? totals.sepService
        : initiativeCostTotals.sepService;
    initiativeCostTotals.sepOther =
      totals.sepOther !== 0 ? totals.sepOther : initiativeCostTotals.sepOther;
    initiativeCostTotals.octMaterial =
      totals.octMaterial !== 0
        ? totals.octMaterial
        : initiativeCostTotals.octMaterial;
    initiativeCostTotals.octService =
      totals.octService !== 0
        ? totals.octService
        : initiativeCostTotals.octService;
    initiativeCostTotals.octOther =
      totals.octOther !== 0 ? totals.octOther : initiativeCostTotals.octOther;
    initiativeCostTotals.novMaterial =
      totals.novMaterial !== 0
        ? totals.novMaterial
        : initiativeCostTotals.novMaterial;
    initiativeCostTotals.novService =
      totals.novService !== 0
        ? totals.novService
        : initiativeCostTotals.novService;
    initiativeCostTotals.novOther =
      totals.novOther !== 0 ? totals.novOther : initiativeCostTotals.novOther;
    initiativeCostTotals.decMaterial =
      totals.decMaterial !== 0
        ? totals.decMaterial
        : initiativeCostTotals.decMaterial;
    initiativeCostTotals.decService =
      totals.decService !== 0
        ? totals.decService
        : initiativeCostTotals.decService;
    initiativeCostTotals.decOther =
      totals.decOther !== 0 ? totals.decOther : initiativeCostTotals.decOther;
  }
}
